console.log('HORAS.JS CARGADO');

(function() {
    const horasContenedor = document.querySelector('#horas');
    if(!horasContenedor) return;

    const categoria = document.querySelector('[name="categoria_id"]');
    const dias = document.querySelectorAll('[name="dia"]');
    const inputHiddenHora = document.querySelector('[name="hora_id"]');
    const inputHiddenDia = document.querySelector('[name="dia_id"]');

    if(!categoria || dias.length === 0) return;

    let busqueda = {
        categoria_id: +categoria.value || '',
        dia: +inputHiddenDia.value || ''
    };

    categoria.addEventListener('change', actualizarBusqueda);
    dias.forEach(dia => dia.addEventListener('change', actualizarBusqueda));

    // 👉 Restaurar datos si estamos editando
    if(!Object.values(busqueda).includes('')) {
        (async () => {
            await buscarCampanas();

            const idHora = inputHiddenHora.value;
            if(!idHora) return;

            const horaSeleccionada = document.querySelector(
                `[data-hora-id="${idHora}"]`
            );

            if(horaSeleccionada) {
                horaSeleccionada.classList.remove('horas__hora--deshabilitada');
                horaSeleccionada.classList.add('horas__hora--seleccionada');
            }
        })();
    }

    function actualizarBusqueda(e) {
        busqueda[e.target.name] = e.target.value;

        // Reset
        inputHiddenHora.value = '';
        inputHiddenDia.value = '';

        const previa = document.querySelector('.horas__hora--seleccionada');
        if(previa) previa.classList.remove('horas__hora--seleccionada');

        if(Object.values(busqueda).includes('')) return;

        buscarCampanas();
    }

    async function buscarCampanas() {
        const { dia, categoria_id } = busqueda;
        const url = `/api/campanas-horario?dia_id=${dia}&categoria_id=${categoria_id}`;

        const respuesta = await fetch(url);
        const campanas = await respuesta.json();

        obtenerHorasDisponibles(campanas);
    }

    function obtenerHorasDisponibles(campanas) {
        const horas = document.querySelectorAll('.horas__hora');

        // Reset
        horas.forEach(hora =>
            hora.classList.add('horas__hora--deshabilitada')
        );

        const horasOcupadas = campanas.map(c => String(c.hora_id));

        horas.forEach(hora => {
            if(!horasOcupadas.includes(hora.dataset.horaId)) {
                hora.classList.remove('horas__hora--deshabilitada');
            }
        });
    }

    // 👉 Delegación de eventos (tu mejora se mantiene)
    horasContenedor.addEventListener('click', seleccionarHora);

    function seleccionarHora(e) {
        const elemento = e.target.nodeType === 3
            ? e.target.parentElement
            : e.target.closest('.horas__hora');

        if(!elemento || elemento.classList.contains('horas__hora--deshabilitada')) {
            return;
        }

        const previa = document.querySelector('.horas__hora--seleccionada');
        if(previa) previa.classList.remove('horas__hora--seleccionada');

        elemento.classList.add('horas__hora--seleccionada');
        inputHiddenHora.value = elemento.dataset.horaId;

        // Guardar día seleccionado
        const diaActivo = document.querySelector('[name="dia"]:checked');
        if(diaActivo) {
            inputHiddenDia.value = diaActivo.value;
        }
    }
})();
